import { render, staticRenderFns } from "./WeightTicket.vue?vue&type=template&id=598325a8"
import script from "./WeightTicket.vue?vue&type=script&lang=js"
export * from "./WeightTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports